<template>
  <div class="left-1 flex jc-sb w100p">
    <div style="width: 100%;">
      <div class="topBox">
        <div class="flex aic jc-sb">
          <div class="flex aic">
            <span
              class="flex aic jc-c"
              :style="{ 'height': '34px', 'width': '34px', 'background-color': is == ' RFQ' ? '#F59A23' : '#EC8880', 'border-radius': '4px' }"
            >
              <i class="iconfont f22 fff" :class="icon"></i>
            </span>
            <div class="flex fdc ml-10 rel">
              <span class="f12 f333">{{ qtnPage }}</span>
              <p class="flex aic fwb f18 f333">
                <span v-if="store.lang == 'en-us'" class="cp">{{ type.name }} {{ store.qtnPage == 4 ? $t('rfq.QTN') : qtnPage }}</span>
                <span v-else class="cp">{{ type.name }}{{ store.qtnPage == 4 ? $t('rfq.QTN') : qtnPage }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="flex aic" style="margin-top: 9px;">
          <!-- 品牌 -->
          <el-select
            v-model="model.brand"
            @change="search"
            class="w20p mr-10"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('slack.Brand')"
            remote-show-suffix
            :remote-method="searchBrand"
            :loading="loading"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
          <!-- 联系人 -->
          <el-select
            v-if="store.type != 4 || store.qtnPage == 3"
            v-model="model.client"
            @change="search"
            class="w20p mr-10"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('slack.Contacts')"
            remote-show-suffix
            :remote-method="userGetRfqContactsList"
            :loading="loading"
          >
            <el-option
              v-for="item in accountList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- 国家 -->
          <el-select
            v-model="model.searchCnty"
            @change="search"
            class="w20p mr-10"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('slack.Countrys')"
            remote-show-suffix
            :remote-method="getUserGetCountry"
            :loading="loading"
          >
            <el-option
              v-for="item in countryList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            />
          </el-select>
          <!-- 状态 -->
          <el-select
            v-if="store.qtnPage != 3 || store.type != 4"
            v-model="model.searchSta"
            @change="search"
            class="w20p mr-10"
            :placeholder="$t('message.state')"
            clearable
          >
            <el-option
              v-for=" item in staOptions "
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- 创建人 -->
          <el-select
            v-if="store.type == 4 && store.qtnPage != 3"
            v-model="model.companyUser"
            @change="search"
            :remote-method="getCompanyUser"
            remote
            filterable
            clearable
            remote-show-suffix
            class="w20p mr-10"
            :placeholder="$t('rfq.Creator')"
          >
            <el-option
              v-for=" item in companyUserList "
              :key="item.user_uid"
              :label="item.nickname"
              :value="item.user_uid"
            />
          </el-select>
          <!-- 来源 -->
          <el-select
            v-model="model.source"
            @change="search"
            class="w20p mr-10"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('slack.source')"
            remote-show-suffix
            :remote-method="getFrom"
            :loading="loading"
          >
            <el-option v-for="item in sourceList" :key="item" :label="item" :value="item" />
          </el-select>
          <el-select
            v-if="store.qtnPage != 1"
            @change="search"
            v-model="model.model"
            :remote-method="getModel"
            remote
            clearable
            remote-show-suffix
            filterable
            class="w20p mr-10"
            :placeholder="$t('slack.Model')"
          >
            <el-option
              v-for=" item in newModel "
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
          <!-- <div class="w25p mr-10">
            <el-date-picker
              v-model="model.inputDate"
              @change="search"
              type="daterange"
              format="YYYY/MM/DD"
              clearable
              value-format="YYYY-MM-DD"
              unlink-panels
              :range-separator="$t('rfq.To')"
              :start-placeholder="$t('file.StartTime')"
              :end-placeholder="$t('file.EndDate')"
              :shortcuts="shortcuts"
              :size="size"
            />
          </div>-->
          <el-input
            v-model="blearSearch"
            @input="search"
            clearable
            class="w20p mr-10"
            :placeholder="$t('rfq.KeyWords')"
            :prefix-icon="Search"
            oninput="value = value.trim()"
          />
          <el-button
            @click="search"
            plain
            style="height: 30px;width: 30px;border: 1px solid #a5a5a5;"
          >
            <i class="iconfont icon-sousuo fwb"></i>
          </el-button>
          <el-button
            @click="clear"
            plain
            style="height: 30px;width: 30px;border: 1px solid #a5a5a5;"
          >
            <i class="iconfont icon-qingkongbiao fwb"></i>
          </el-button>
          <el-button
            @click="emits('flush')"
            plain
            style="height: 30px;width: 30px;border: 1px solid #a5a5a5;"
          >
            <i
              class="iconfont icon-shuaxin fwb"
              :style="loading ? 'animation: loading-rotate 1s linear infinite;' : ''"
            ></i>
          </el-button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="mt-15" style="height: calc(100% - 140px);">
        <el-table
          :data="data"
          v-loading="loading"
          v-el-table-infinite-scroll="scrollLoad"
          border
          ref="dataTable"
          highlight-current-row
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          height="100%"
          :header-cell-style="{ 'background-color': '#F2F4F7', 'font-weight': 'bold', }"
          style="width: 100%;"
          :row-class-name="rowClassName"
        >
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column prop="inquiry_id" label="ID" show-overflow-tooltip>
            <template v-slot="scope">
              <div class="flex aic">
                <span
                  @click="emits('cell-click', scope.row)"
                  style="color: #3370FF;cursor: pointer;text-decoration: underline;white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;"
                >{{ scope.row.inquiry_id }}</span>
                <p
                  v-show="scope.row.createByUser != '' && store.type == 4"
                  style="font-size: 13px;margin-left: 10px;background-color: #00D6B9;border-radius: 4px;color: #fff;height: 16px;padding: 0 5px;line-height: 16px;"
                >from {{ scope.row.createByUser }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="store.qtnPage == 1"
            prop="vendor"
            :label="$t('rfq.vendor')"
            show-overflow-tooltip
          >
            <template #header>
              <comTip :text="$t('rfq.vendor')"></comTip>
            </template>
          </el-table-column>
          <el-table-column v-else :label="$t('rfq.contact')" show-overflow-tooltip>
            <template #header>
              <comTip :text="$t('rfq.contact')"></comTip>
            </template>
            <template v-slot="scope">
              <span v-if="store.type != 4">
                {{ Kernaldec(scope.row.customer.firstname) }}
                {{ Kernaldec(scope.row.customer.lastname) }}
              </span>
              <span v-else>
                {{ Kernaldec(scope.row.customer.firstname) }}
                {{ Kernaldec(scope.row.customer.lastname) }}
              </span>
            </template>
          </el-table-column>
          <!-- 客户公司 -->
          <el-table-column prop="account" :label="$t('rfq.accout')" show-overflow-tooltip>
            <template #header>
              <comTip :text="$t('rfq.accout')"></comTip>
            </template>
            <template #default="scope">
              <span>{{ scope.row.account || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="country.name" :label="$t('rfq.cnty')" show-overflow-tooltip>
            <template #header>
              <comTip :text="$t('rfq.cnty')"></comTip>
            </template>
            <template #default="scope">
              <span v-if="scope.row.country">{{ scope.row.country.name || '-' }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="store.qtnPage != 3 || store.type != 4"
            prop="owner"
            label="Owner"
            width="100"
            show-overflow-tooltip
          >
            <template #header>
              <comTip text="Owner"></comTip>
            </template>
          </el-table-column>
          <el-table-column
            prop="items_count"
            :label="$t('rfq.items')"
            width="80"
            show-overflow-tooltip
          >
            <template #header>
              <comTip :text="$t('rfq.items')"></comTip>
            </template>
          </el-table-column>
          <!-- 来源 -->
          <el-table-column :label="$t('rfq.source')" show-overflow-tooltip>
            <template #header>
              <comTip :text="$t('rfq.source')"></comTip>
            </template>
            <template #default="scope">
              <span>{{ scope.row.from == '' ? '-' : scope.row.from }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('rfq.status')" width="170" show-overflow-tooltip>
            <template #header>
              <comTip :text="$t('rfq.status')"></comTip>
            </template>
            <template #default="scope">
              <el-tag :color="tagCloor(scope.row)" style="border: none;">
                <p :class="[$resizeFont(12), 'flex aic f333']" style="font-weight: 500;">
                  <span>{{ scope.row.qtn_state }}</span>
                  <span>({{ scope.row.finishItem }} / {{ scope.row.items_count }})</span>
                </p>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            v-if="store.qtnPage == 2 && store.type == 4"
            prop="createUser"
            :label="$t('rfq.Creator')"
            show-overflow-tooltip
          >
            <template #header>
              <comTip :text="$t('rfq.Creator')"></comTip>
            </template>
            <template #default="{ row }">
              <span
                v-if="((row.createUserOrgId == store.org_id && store.tyep == 1) || row.create_user == store.user_uid || row.user_uid == store.user_uid) || store.type != 3"
              >
                {{
                row.createUser == '' ? '-' : row.createUser }}
              </span>
              <span v-else>******</span>
            </template>
          </el-table-column>
          <el-table-column prop="qtn_create_time" :label="$t('main.date')" width="140">
            <template #header>
              <comTip :text="$t('main.date')"></comTip>
            </template>
          </el-table-column>
          <template #empty>
            <empty size="150" height="calc(100vh - 400px)" color="#999999">
              <p class="mt-20 f20">{{ $t('rfq.noData') }}</p>
            </empty>
          </template>
        </el-table>
      </div>
      <div class="flex jc-e mt-15 mb-15" style="height: 32px;">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[20, 30, 40, 50, 100]"
          :small="small"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="emits('size-change', $event)"
          @current-change="emits('current-change', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import comTip from "@/components/comView/comTip.vue"
import { ArrowDown, Search } from "@element-plus/icons-vue";
import { Kernaldec } from "@/hooks/useDecrypt";
import { useDemoStore } from "@/pinia/index";
import i18n from "@/assets/lang";
const store = useDemoStore();
import { HomeStore } from "@/slack/index.js";

const props = defineProps({
  data: Array, //表格数据
  inquiry_id: Number,
  loading: Boolean, //加载
  show: Boolean, //展开/关闭
  type: Object, //类型
  total: {
    //总页数
    type: Number,
    default: 0
  },
  currentPage: Number, //当前页数
  pageSize: Number, //每页显示条目个数
  rowClassName: Number, //表格高亮
  supplierOptions: Array, //供应商
  staOptions: Array, //状态
  gesUserSalesList: Array, //人员列表
  companyUserList: Array, // 公司下的用户列表
  accountList: Array, //客户列表
  countryList: Array, //国家列表
  newModel: Array, // 型号列表
  sourceList: Array, // 来源列表
  brandList: Array, //品牌列表
  is: {
    type: String,
    default: ""
  },
  icon: String,
  rfq: Object, //询盘按钮权限
  qtn: Object, //报价按钮权限
  fuzzySearch: String //模糊搜索的值
});

// 按钮权限
const qtnNewPower = store.powerList.QTN;
// 标签颜色
const tagCloor = row => {
  if (store.qtnPage != 2) {
    //报价状态
    if (row.qtnStateCode == 0) {
      //待报价
      return "#FFAE577E";
    } else if (row.qtnStateCode == 1) {
      //采购已报价
      return "#DA99FF80";
    } else if (row.qtnStateCode == 2) {
      //销售已报价
      return "#55BDE67D";
    } else if (row.qtnStateCode == 3) {
      //已完成
      return "#7FC03580";
    }
  } else {
    //询盘状态
    if (row.stateCode == 0) {
      //草稿
      return "#CBCE0044";
    } else if (row.stateCode == 1) {
      //待报价
      return "#FFAE577E";
    } else if (row.stateCode == 3) {
      //采购已报价
      return "#DA99FF80";
    } else if (row.stateCode == 4) {
      //销售已报价
      return "#55BDE67D";
    } else if (row.stateCode == 9) {
      //已完成
      return "#7FC03580";
    }
  }
};
const getNewPower = () => {
  if (store.qtnPage == 2) {
    //Purchase
    return qtnNewPower.purchase.handle_auth.new.Isenable;
  } else if (store.qtnPage == 3 && store.type != 4) {
    //Contact's
    return qtnNewPower.contact.handle_auth.new.Isenable;
  }
};
let dataTable = ref("");
const handleCurrentChange = e => {
  if (e) {
    HomeStore().selectData = e;
    dataTable.value.toggleRowSelection(e, true);
  }
};
const handleSelectionChange = e => {
  if (e.length > 0) {
    dataTable.value.setCurrentRow(e[e.length - 1]);
    e.map((item, index) => {
      if (index == e.length - 1) {
        dataTable.value.toggleRowSelection(item, true);
      } else {
        dataTable.value.toggleRowSelection(item, false);
      }
    });
  } else {
    dataTable.value.setCurrentRow("");
    HomeStore().selectData = "";
  }
};
// 判断当前在那个页面
const qtnPage = computed(() => {
  if (store.qtnPage == 1) {
    return i18n.global.t("rfq.myQTN");
  } else if (store.qtnPage == 2) {
    return i18n.global.t("rfq.PurchaseQTN");
  } else if (store.qtnPage == 3) {
    return i18n.global.t("rfq.ContactsQTN");
  } else {
    return i18n.global.t('rfq.myQTN')
  }
});

// 禁用tab
document.addEventListener("keydown", function(event) {
  if (event.keyCode === 9) {
    event.preventDefault();
  }
});

// 全部人员
const allPersonnel = ref("");

const blearSearch = ref(""); //模糊搜索输入框

// 搜索绑定的值
const model = ref({
  model: "",
  client: "",
  searchCnty: "",
  searchSupplier: "",
  searchSta: "",
  inputDate: "",
  companyUser: "",
  brand: "",
  source: ""
});

watch(
  () => props.fuzzySearch,
  e => {
    blearSearch.value = e;
  }
);

// watch(() => props.inquiry_id, ((e) => {
//     model.value.inquiry = e
// }))

// 日期处理事件
const shortcuts = [
  {
    text: i18n.global.t("rfq.LastWeek"),
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    }
  },
  {
    text: i18n.global.t("rfq.LastMonth"),
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    }
  },
  {
    text: i18n.global.t("rfq.Last3Months"),
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      return [start, end];
    }
  }
];

// 共用搜索事件
const search = () => {
  emits("search", model.value);
  emits("blearSearch", blearSearch.value);
};

// 清空\重置
const clear = () => {
  model.value.model = "";
  model.value.client = "";
  model.value.searchCnty = "";
  model.value.searchSupplier = "";
  model.value.searchSta = "";
  model.value.inputDate = "";
  model.value.companyUser = "";
  model.value.source = "";
  model.value.brand = "";
  blearSearch.value = "";
  search();
};

// 搜索型号
const getModel = e => {
  emits("getModel", e);
};

// 搜索客户
const userGetRfqContactsList = e => {
  emits("userGetRfqContactsList", e);
};

// 搜索国家
const getUserGetCountry = e => {
  emits("getUserGetCountry", e);
};

// 搜索品牌
const searchBrand = e => {
  emits("searchBrand", e);
};

// 搜索来源
const getFrom = e => {
  emits("getFrom", e);
};

const scrollLoad = () => {
  //触底触发
  emits("scrollLoad");
};

const emits = defineEmits([
  "cell-click",
  "scrollLoad",
  "size-change",
  "current-change",
  "close",
  "flush",
  "typeChange",
  "blearSearch",
  "search",
  "new",
  "getPersonnel",
  "getCompanyUser",
  "getUserGetAccountList",
  "getUserGetCountry",
  "scroll",
  "getModel",
  "userGetRfqContactsList",
  "getFrom",
  "searchBrand"
]);

/**
 * cell-click  点击单元格触发
 * scrollLoad  触底触发
 * size-change  每次显示多少条，改变触发
 * current-change  当前显示第几页，改变触发
 * close  关闭表格
 * flush 刷新页面
 * typeChange  更改类型触发
 * blearSearch 右上角输入框搜索触发
 * search 行内搜索触发
 * new new按钮触发
 */
</script>
<style lang="less" scoped>
.left-1 {
  height: 100%;
  width: calc(100% - 30px);
  margin: 0 15px;
  border-radius: 4px;
  background-color: #fff;
  .topBox {
    background-color: #ffffff;
    height: 85px;
    border-radius: 4px 4px 0 0;
  }

  .title {
    color: #707070;
    font-weight: bold;
    margin-top: 10px;
  }

  /deep/.el-table th.el-table__cell {
    padding: 7px 0;
    color: #333333;
  }

  /deep/.el-table .el-table__cell {
    padding: 4px 0;
    font-size: 13px;
  }

  /deep/.el-table tr {
    //单元格高度
    height: 40px;
  }

  /deep/.el-date-editor--daterange,
  .el-date-editor--timerange {
    width: 100%;
  }

  /deep/.el-table {
    --el-table-row-hover-bg-color: #e6f0ff;
    color: #333333;
    --el-table-border: 1px solid #f2f2f2;
    --el-table-border-color: #ffffff00;
    border: 1px solid #cad2d9;
    border-radius: 4px;
  }

  /deep/.el-table .cell {
    //表格间距
    padding: 0 8px;
    white-space: nowrap;
  }

  /deep/.el-table--border .el-table__cell {
    //虚线
    border-right: none;
    // border-right: 1px dashed #CAD2D9;
  }

  /deep/ .el-table th.el-table__cell {
    color: #333333;
    border-right: 1px solid #d7e2ed;
  }

  /deep/ .el-table th.el-table__cell:last-child {
    border: none;
  }

  /deep/.el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    //斑马线颜色
    background-color: #f9fbfd;
  }

  /deep/.el-table--striped .el-table__body tr:hover td {
    //鼠标经过斑马纹
    background-color: #e6f0ff !important;
  }

  /deep/.el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #f2f2f2;
  }

  /deep/.el-input {
    --el-input-focus-border: #d7e2ed;
    --el-input-hover-border-color: #bacefd;
    --el-input-focus-border-color: #3370ff;
  }

  /deep/.el-select {
    --el-select-border-color-hover: #bacefd;
    --el-select-input-focus-border-color: #3370ff;
  }

  /deep/.el-pagination .el-select .el-input {
    //一次查看多少条数宽度
    width: 97px;
  }

  /deep/.el-pagination__editor.el-input {
    //跳转到第几页的按钮宽度
    width: 50px;
  }

  /deep/.el-pager li.is-active {
    //page颜色
    color: #3370ff;
    border: 1px solid #3370ff;
    border-radius: 4px;
  }

  /deep/.el-pager li {
    margin: 0 5px;
    border: 1px solid #d7e2ed;
    border-radius: 4px;
  }

  /deep/.el-table thead {
    //表头高度
    height: 40px;
  }

  /deep/ .el-pagination {
    --el-pagination-hover-color: #3370ff;
  }
}
</style>